import { scaleBand, scaleLinear, scaleTime } from 'd3-scale';
import { extent } from 'd3-array';


export const bandScale = (data, dimensionKey, range) => {
  const length = data.length;

  return scaleBand()
    .range([range.min, range.max])
    .paddingOuter(length < 4 || length > 8 ? .3 : .15)
    .paddingInner(length < 4 ? .8 : .6)
    .domain(data.map(d => d[dimensionKey]));
};

export const timeSeriesScale = (data, dimensionKey, range) => {
  return scaleTime()
    .range([range.min, range.max])
    .domain(extent(data, (d) => d[dimensionKey]));
};

export const linearScale = (range, domain) => {
  return scaleLinear()
    .range([range.min, range.max])
    .domain([domain.min, domain.max]);
};




